import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { GeneralService } from 'src/app/providers/general/general.service';
import { ExcelService } from 'src/app/service/excelService/excel.service';
import { GetExcelService } from 'src/app/providers/excel/get-excel.service';
declare let $: any;
@Component({
  selector: 'app-self-covid-declaration-form',
  templateUrl: './self-covid-declaration-form.component.html',
  styleUrls: ['./self-covid-declaration-form.component.scss']
})
export class SelfCovidDeclarationFormComponent implements OnInit {

  formQus = [
    {name: 'Dose 1 Registration', radio: 'frstRow', status: 'N', isDisabled: false},
    {name: 'Dose 1', radio: 'scndRow', status: 'N', isDisabled: true},
    {name: 'Dose 2 Registration', radio: 'thrdRow', status: 'N', isDisabled: true},
    {name: 'Dose 2', radio: 'fourthRow', status: 'N', isDisabled: true},
    {name: 'Booster Dose Registration', radio: 'ffthRow', status: 'N', isDisabled: true},
    {name: 'Booster Dose', radio: 'sxthRow', status: 'N', isDisabled: true},
  ];
  empName;
  empID;
  userID;
  vaccineFrom;
  dropDown: any = [];
  vaccineData: any = [];
  // declaredropDown: any = [];
  roleWiseCostCenter: any = [];
  isOther = false;
  submit = false;
  vaccStatus = false;
  declare;
  vaccineForm: FormGroup;
  vaccination;
  otherReason = '';
  editID;
  
  constructor(private httpDash: DashboardService,
              private notifyService: NotificationService,
              private location: Location,
              private formBuilder: FormBuilder,
              private generalServe: GeneralService,
              private excelServ: ExcelService,
              public httpBasePath: GetExcelService) { 
                
              }

  ngOnInit(): void {
    this.empDetail();
    this.getVaccFromOption();
    this.permissionFormField();
    
  }

  get vaccineError(): any { return this.vaccineForm.controls; }

  vaccinationReport(): void{
    this.httpDash.vacinDeclareReport().subscribe(res => {
      if (res.status) {
        const header = res.header;
        const reportData = {
          title: 'Vaccine Declare Report',
          data: res.data,
          headers: Object.values(header)
        };
        this.excelServ.exportKudosDump(reportData);
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  permissionFormField(): void {
    this.vaccineForm = this.formBuilder.group({
      cc_id: ['', Validators.required],
      vacc_from: ['', Validators.required],
      vacc_data: ['', Validators.required],
    });
  }

  openModal(id): void {
    this.getRoleWiseCostCenters();
    $(id).modal({ backdrop: 'static', keyboard: false });
  }

  getRoleWiseCostCenters(): void {
    this.generalServe.getEmpCostCenters('7').subscribe(res => {
      this.roleWiseCostCenter = res.data;
    });
  }

  closeModal(): void {
    this.submit = false;
    this.vaccineForm.reset();
  }

  empDetail(): void {
    this.httpDash.getLoggedInEmpDetails().subscribe(res => {
      this.empName = res.data.emp_name;
      this.empID = res.data.username;
      this.userID = res.data.id;
      this.getEmpVaccInfo(this.userID);
    });
  }

  getVaccFromOption(): void {
    this.httpDash.getOptions(13).subscribe(res => {
      this.dropDown = res.data;
    });
  }

  getEmpVaccInfo(userID): void {
    this.httpDash.vaccineDataGet(userID).subscribe(res => {
      if (res.status) {
      this.editID = res.data.id;
      this.vaccineFrom = res.data.vacc_frm;
      this.otherReason = res.data.rsn;
      if (this.vaccineFrom == 207) {
        this.isOther = true;
      } else {
        this.isOther = false;
      }
      this.formQus[0].status = res.data.dose_1_reg;
      this.formQus[1].status = res.data.dose_1;
      this.formQus[2].status = res.data.dose_2_reg;
      this.formQus[3].status = res.data.dose_2;
      this.formQus[4].status = res.data.dose_3_reg;
      this.formQus[5].status = res.data.dose_3;
      this.vaccination = res.data.vacc_decl;
      }
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.formQus.length; i ++) {
        if (i + 1 === this.formQus.length) {
          return;
        } else {
          if (this.formQus[i].status == 'Y' || this.formQus[i].status == 'y') {
            this.formQus[i].isDisabled = false;
            this.formQus[i + 1].isDisabled = false;
          }
        }
      }
    });
  }

  vaccinationChange(): void {
    if (this.vaccination === 'R' || this.vaccination === 'N') {
      this.formQus.forEach(el => {
        el.isDisabled = true;
        el.status = 'N';
      });
    } else {
      this.formQus[0].isDisabled = false;
      this.formQus[0].status = 'N';
    }
  }

  changeDose(index): void {
    const temp = this.formQus[index];
    if (index + 1 === this.formQus.length) {
      return ;
    } else {
      if (temp.status === 'Y') {
        this.formQus[index + 1].isDisabled = false;
      } else {
        this.deSelectLoop(index + 1);
      }
    }
  }

  deSelectLoop(start): void {
    for (let i = start; i < this.formQus.length; i++) {
      this.formQus[i].isDisabled = true;
      this.formQus[i].status = 'N';
    }
  }

  onUploadVaccineData(event): void {
    this.vaccineData = [];
    const tmpExt = event.target.value.split('.');
    if (tmpExt[1] !== 'xlsx') {
      this.vaccineForm.get('vacc_data').reset();
      this.notifyService.showInfo('Please Upload only .xlsx file', 'Info!');
    } else {
      const workbook = new Excel.Workbook();
      const target: DataTransfer = (event.target) as DataTransfer;
      if (target.files.length !== 1) {
        throw new Error('Cannot use multiple files');
      }

      const arryBuffer = new Response(target.files[0]).arrayBuffer();
      arryBuffer.then(data => {
        workbook.xlsx.load(data).then(() =>  {
            const tmp = [];
            const worksheet = workbook.getWorksheet();
            worksheet.eachRow(row => {
              const temp = [];
              row.values.forEach((e, index) => {
                if (index > 0 && index < 8){
                  temp.push(e);
                }
              });
              tmp.push(temp);
            });
            this.vaccineData = tmp;
          });
      });
    }
  }

  getVaccDeclareOption(): void {
    // this.httpDash.getOptions(14).subscribe(res => {
    //   this.declaredropDown = res.data;
    // });
  }

  vaccineFromChange(event): void {
    if (event.target.value) {
      this.vaccStatus = true;
      if (event.target.value == 207) {
        this.isOther = true;
      } else {
        this.otherReason = '';
        this.isOther = false;
      }
    } else {
      this.vaccStatus = false;
    }
  }

  submitSelfCovid(): void {
    if (!this.vaccineFrom) {
      this.notifyService.showError('Please Select your vaccination source', 'Info!');
      return ;
    }
    if (this.isOther && !this.otherReason) {
      this.notifyService.showError('Please enter the Reason ', 'Info!');
      return;
    }
    if (!this.declare) {
      this.declare = '';
    }
    if (!this.otherReason) {
      this.otherReason = '';
    }
    if (!this.editID) {
      this.editID = '';
    }
    const covidForm = new FormData();
    covidForm.append('id', this.editID);
    covidForm.append('user_id', this.userID);
    covidForm.append('vacc_frm', this.vaccineFrom);
    covidForm.append('rsn', this.otherReason);
    covidForm.append('vacc_decl', this.declare);
    covidForm.append('dose_1_reg', this.formQus[0].status);
    covidForm.append('dose_1', this.formQus[1].status);
    covidForm.append('dose_2_reg', this.formQus[2].status);
    covidForm.append('dose_2', this.formQus[3].status);
    covidForm.append('dose_3_reg', this.formQus[4].status);
    covidForm.append('dose_3', this.formQus[5].status);
    this.httpDash.addVaccineDetail(covidForm).subscribe(res => {
      if (res.status) {
        this.location.back();
        this.notifyService.showSuccess(res.msg, 'Success!');
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  submitVaccineData(): void {
    this.submit = true;
    if (this.vaccineForm.invalid) {
      return ;
    } else {
      const tempObj = {
        vacc_frm: this.vaccineForm.get('vacc_from').value,
        cc_id: this.vaccineForm.get('cc_id').value,
        vacc_decl: this.vaccineData
      };
      this.httpDash.bulUploadVaccData(tempObj).subscribe(res => {
        if (res.status) {
          this.closeModal();
          $('#upload_vacc_data').modal('hide');
          this.notifyService.showSuccess(res.msg, 'Success!');
        } else {
          this.vaccineForm.reset();
          if (res.error_flag == 1) {
            this.notifyService.showData(JSON.stringify(res.Emp_id), 'Info!');
          } else {
            this.notifyService.showError(res.msg, 'Info!');
          }
        }
      });
    }
  }
}
